import { render } from "./bulkImport.vue?vue&type=template&id=27bc0948&scoped=true"
import script from "./bulkImport.vue?vue&type=script&lang=js"
export * from "./bulkImport.vue?vue&type=script&lang=js"

import "./bulkImport.vue?vue&type=style&index=0&id=27bc0948&lang=scss&scoped=true"

import exportComponent from "D:\\project\\cloud-api-web-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27bc0948"]])

export default __exports__